import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import PrepaymentFormData from "~/store/PrepaymentFormData.js";
import { FormText, FormTitle } from "~/features/doctorForm/FormLayout";

export const CONDITIONS_TITLE =
  "Condições da proposta da antecipação de valores realizada pela (ANTECIPE PAGAMENTOS E PARTICIPAÇÕES S/A.) para você!";

// Textos legais mantidos literalmente da versão anterior deste passo.
const CLAUSES = [
  [
    "Cláusula 01 - Critérios para antecipação:",
    "consultará à empresa selecionada na Seção 02 em que você realizou plantões os créditos disponíveis ao médico para recebimento conforme a seleção realizada nas Seções 4, 5 e 6 abaixo neste formulário.",
  ],
  [
    "Cláusula 02 - Custos da antecipação:",
    "aplicará sobre os créditos líquidos, conforme item acima, que o médico tiver a receber junto à empresa selecionada em que realizou plantões a taxa de serviço de 09,90% para antecipações de plantões a receber em até 30 dias, 16,50% para antecipações para plantões a receber daqui 31 e 60 dias e 19,90% para antecipações de plantões que você tem a receber entre 61 e 90 dias, contados a partir da data de recebimento da antecipação até a data estabelecida para repasse ao médico pela empresa selecionada em que realizou plantões.",
  ],
  [
    "Cláusula 03 - Segurança da antecipação:",
    "assume todos os riscos relacionados à compra realizada dos créditos devidos ao médico pela empresa selecionada em que realizou plantões mediante a antecipação contratada. Nenhum valor adicional será cobrado ao médico caso a ANTECIPE PAGAMENTOS não receba os valores compensatórios correspondentes à realização da antecipação contratada.",
  ],
  ["Cláusula 04 - Período para resposta:", "retornará resposta ao médico em até 24 horas úteis após o envio desta solicitação."],
  [
    "Cláusula 05 - Contratação da antecipação:",
    "avaliará a solicitação realizada através do preenchimento deste formulário somente mediante a concordância do médico das Seções 03 e 04 e, confirmada viabilidade pela empresa selecionada em que realizou plantões, emitirá documento ao médico para contratação da antecipação por assinatura digital via e-mail.",
  ],
  ["Cláusula 06 - Prazo para recebimento:", "realizará a antecipação dos valores em até 24h úteis após a contratação."],
];

const Step2 = ({ setDisabledNext, mobile }) => {
  const [accepted, setAccepted] = useState(PrepaymentFormData.data.acceptTerms);
  useEffect(() => {
    setDisabledNext(!accepted);
  }, [accepted, setDisabledNext]);

  return (
    <Box>
      <FormTitle mobile={mobile}>{CONDITIONS_TITLE}</FormTitle>
      <Box component="ol" sx={{ listStyle: "none", p: 0, m: 0, mt: 3, display: "grid", gap: 2 }}>
        {CLAUSES.map(([title, body]) => (
          <Box component="li" key={title} sx={{ pl: 2, borderLeft: "3px solid #05bbe5" }}>
            <Typography sx={{ fontSize: 15, fontWeight: 600, color: "primary.main" }}>{title}</Typography>
            <FormText sx={{ mt: 0.5 }}>
              A <b>ANTECIPE PAGAMENTOS</b> {body}
            </FormText>
          </Box>
        ))}
      </Box>
      <Box sx={{ mt: 4, p: 2, borderRadius: 2, bgcolor: "#f5f7fa", border: "1px solid #e5e7eb" }}>
        <FormText>
          Concordo com os termos contidos nas cláusulas acima para que a <b>ANTECIPE PAGAMENTOS</b> me realize oferta de antecipação de recebimentos de acordo
          com meus créditos a receber junto as empresas médicas.
        </FormText>
        <FormControlLabel
          sx={{ mt: 1 }}
          control={
            <Checkbox
              checked={accepted}
              onChange={(e) => {
                PrepaymentFormData.setAcceptTerms(e.target.checked);
                setAccepted(e.target.checked);
              }}
            />
          }
          label={<b>Sim, estou de acordo.</b>}
        />
      </Box>
    </Box>
  );
};

export default Step2;
